import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect } from "react";
import mixpanel from "mixpanel-browser";
import { getAllSources, getIsOnpremise, getPlatform, isWebView } from ".";
import constants from "./constants";
import { get, isEmpty } from "lodash";
import { MIXPANEL_EVENTS, MIXPANEL_OTHER_EVENTS } from "./mixpanelEvents";
import getEnv from "./getEnv";
import Countly from "countly-sdk-web";
import getConfig from "next/config";
import isMobile from "./isMobile";
var PROD = "production";
var LOCALSTORAGE = "localStorage";
var isProduction = getEnv("NEXT_PUBLIC_APP_ENV") === PROD;
function getUserProperties(userData) {
  var _userData$details, _userData$details2, _userData$details3, _userData$details4, _userData$details5, _userData$details6;
  var sources = getAllSources(userData);
  var sourceIds = sources.map(function (source) {
    return source.uuid;
  });
  var PLATFORMS = constants.PLATFORMS;
  var platform = Object.keys(PLATFORMS).find(function (p) {
    return PLATFORMS[p] === getPlatform();
  });
  return {
    Name: userData === null || userData === void 0 || (_userData$details = userData.details) === null || _userData$details === void 0 ? void 0 : _userData$details.name,
    Email: userData === null || userData === void 0 || (_userData$details2 = userData.details) === null || _userData$details2 === void 0 ? void 0 : _userData$details2.email,
    sourceIdentifier: (userData === null || userData === void 0 || (_userData$details3 = userData.details) === null || _userData$details3 === void 0 ? void 0 : _userData$details3.source_identifier) || "personal_user",
    country: userData === null || userData === void 0 || (_userData$details4 = userData.details) === null || _userData$details4 === void 0 ? void 0 : _userData$details4.country,
    vertical: userData === null || userData === void 0 || (_userData$details5 = userData.details) === null || _userData$details5 === void 0 ? void 0 : _userData$details5.vertical,
    clientName: userData === null || userData === void 0 || (_userData$details6 = userData.details) === null || _userData$details6 === void 0 ? void 0 : _userData$details6.client_name,
    sourceIds: sourceIds,
    isMobileApp: isWebView(),
    platform: platform
  };
}
function getCountlyFormattedUserProperties(userData) {
  var _getConfig, _userData$details7, _userData$details8, _userData$details9, _userData$details0, _userData$details1, _userData$details10, _userData$details11;
  var sources = getAllSources(userData);
  var sourceIds = sources.map(function (source) {
    return source.uuid;
  });
  var PLATFORMS = constants.PLATFORMS;
  var platform = Object.keys(PLATFORMS).find(function (p) {
    return PLATFORMS[p] === getPlatform();
  });
  var appVersion = ((_getConfig = getConfig()) === null || _getConfig === void 0 || (_getConfig = _getConfig.publicRuntimeConfig) === null || _getConfig === void 0 ? void 0 : _getConfig.version) || "unknown";
  return {
    name: userData === null || userData === void 0 || (_userData$details7 = userData.details) === null || _userData$details7 === void 0 ? void 0 : _userData$details7.name,
    username: userData === null || userData === void 0 || (_userData$details8 = userData.details) === null || _userData$details8 === void 0 ? void 0 : _userData$details8.email,
    email: userData === null || userData === void 0 || (_userData$details9 = userData.details) === null || _userData$details9 === void 0 ? void 0 : _userData$details9.email,
    app_version: appVersion,
    custom: {
      sourceIds: sourceIds,
      isMobileApp: isWebView(),
      platform: platform,
      sourceIdentifier: (userData === null || userData === void 0 || (_userData$details0 = userData.details) === null || _userData$details0 === void 0 ? void 0 : _userData$details0.source_identifier) || "personal_user",
      country: userData === null || userData === void 0 || (_userData$details1 = userData.details) === null || _userData$details1 === void 0 ? void 0 : _userData$details1.country,
      vertical: userData === null || userData === void 0 || (_userData$details10 = userData.details) === null || _userData$details10 === void 0 ? void 0 : _userData$details10.vertical,
      clientName: userData === null || userData === void 0 || (_userData$details11 = userData.details) === null || _userData$details11 === void 0 ? void 0 : _userData$details11.client_name,
      appVersion: appVersion,
      deviceName: getEnv("NEXT_PUBLIC_DEVICE_NAME") || "unknown"
    }
  };
}
var isLoggedInUser = function isLoggedInUser() {
  var userInfo = window.userInfo;
  return get(userInfo, ["authenticated"], false);
};
function initMixpanel() {
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  var isOnPremise = getIsOnpremise();
  if (isOnPremise || !MIXPANEL_TOKEN) {
    return function () {};
  }
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: !isProduction,
    track_pageview: false,
    persistence: LOCALSTORAGE
  });
  return function (userData) {
    mixpanel.identify(userData.username);
    mixpanel.register({
      loginSource: userData === null || userData === void 0 ? void 0 : userData.loginSource
    });
    var userProperties = getUserProperties(userData);
    mixpanel.people.set_once(userProperties);
  };
}
var trackPageView = function trackPageView(pageName) {
  var isOnPremise = getIsOnpremise();
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (isOnPremise || !MIXPANEL_TOKEN || !isLoggedInUser()) {
    return;
  }
  try {
    mixpanel.track_pageview({
      page: pageName
    });
    trackDuration(MIXPANEL_OTHER_EVENTS.PAGE_EXIT);
  } catch (e) {
    console.error("Mixpanel not initialized :", e);
  }
};
var trackEvent = function trackEvent(name, props, duration) {
  var isOnPremise = getIsOnpremise();
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");

  // to be moved to other condition once on-prem build is ready
  trackCountlyEvent({
    key: name,
    segs: props,
    dur: duration
  });
  if (isOnPremise || !isLoggedInUser()) {
    return;
  }
  if (!MIXPANEL_TOKEN) {
    return;
  }
  if (isEmpty(props)) {
    mixpanel.track(name);
    return;
  }
  try {
    mixpanel.track(name, props);
  } catch (e) {
    console.error("Mixpanel not initialized :", e);
  }
};
var trackPageExit = function trackPageExit(page) {
  var isOnPremise = getIsOnpremise();
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (isOnPremise || !MIXPANEL_TOKEN || !isLoggedInUser()) {
    return;
  }
  mixpanel.track(MIXPANEL_OTHER_EVENTS.PAGE_EXIT, {
    page: page
  });
};
var storeMixpanelEvents = function storeMixpanelEvents(name) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var events = localStorage.getItem(constants.PERSISTED.mixpanelEvents) || "[]";
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (events && MIXPANEL_TOKEN) {
    var eventsArray = JSON.parse(events);
    var _event = {
      name: name,
      properties: _objectSpread(_objectSpread({}, properties), {}, {
        timestamp: new Date().toISOString()
      })
    };
    eventsArray.push(_event);
    localStorage.setItem(constants.PERSISTED.mixpanelEvents, JSON.stringify(eventsArray));
  }
};
var syncMixpanelEvents = function syncMixpanelEvents() {
  var events = localStorage.getItem(constants.PERSISTED.mixpanelEvents);
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (events && MIXPANEL_TOKEN) {
    var eventsArray = JSON.parse(events);
    eventsArray.forEach(function (event) {
      mixpanel.track(event.name, event.properties);
    });
    localStorage.removeItem(constants.PERSISTED.mixpanelEvents);
  }
};

/* this function will track duration will target event is hit */
var trackDuration = function trackDuration(targetEvent) {
  var isOnPremise = getIsOnpremise();
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (isOnPremise || !MIXPANEL_TOKEN || !isLoggedInUser()) {
    return;
  }
  mixpanel.time_event(targetEvent);
};
function initializeCountly() {
  var _window;
  var isOnPremise = getIsOnpremise();
  var APP_KEY = getEnv("NEXT_PUBLIC_COUNTLY_APP_KEY");
  var COUNTLY_URL = "http://".concat((_window = window) === null || _window === void 0 ? void 0 : _window.location.hostname, ":").concat(getEnv("NEXT_PUBLIC_COUNTLY_PORT"));

  // disabled countly for cloud builds
  if (!isOnPremise || !APP_KEY) {
    return function () {};
  }
  Countly.init({
    // server credentials
    app_key: APP_KEY,
    url: COUNTLY_URL,
    debug: !isProduction
  });
  Countly.track_sessions();
  Countly.track_errors();
  Countly.q.push(["disable_heatmaps"]);
  return function (userData) {
    var _userData$details12;
    var deviceId = (userData === null || userData === void 0 ? void 0 : userData.username) || (userData === null || userData === void 0 || (_userData$details12 = userData.details) === null || _userData$details12 === void 0 ? void 0 : _userData$details12.email) || "";
    if (isMobile()) {
      deviceId = "".concat(deviceId, "_mobile");
    }
    Countly.set_id(deviceId);
    var userProperties = getCountlyFormattedUserProperties(userData);
    trackCountlyUserProfile(userProperties);
    // if userData has the loginSource then add to countlyEvent
    if (!isEmpty(userData === null || userData === void 0 ? void 0 : userData.loginSource)) {
      trackCountlyEvent({
        key: MIXPANEL_EVENTS.LOGIN_SOURCE,
        segs: {
          loginSource: userData === null || userData === void 0 ? void 0 : userData.loginSource
        }
      });
    }
  };
}
var trackCountlyEvent = function trackCountlyEvent(_ref) {
  var key = _ref.key,
    dur = _ref.dur,
    segs = _ref.segs;
  Countly.q.push(["add_event", {
    key: key,
    dur: dur,
    segmentation: segs
  }]);
};
function trackCountlyUserProfile(userProfile) {
  Countly.q.push(["user_details", userProfile]);
}

/**
 * Track a page view event in Mixpanel with a page name parameter.
 * Kept for later use
 * @param pageName - The name of the page to track
 */
var trackCountlyPageView = function trackCountlyPageView(pageName, segments) {
  var isOnPremise = getIsOnpremise();
  if (!isOnPremise || !isLoggedInUser()) {
    return;
  }
  Countly.q.push(["track_pageview", pageName, [], segments]);
};

/**
 * React hook to track Countly view start and end for modals or components.
 * Kept for later use
 * @param viewName - The name of the view to track
 * @param active - Whether the view is active (open/mounted)
 */
export function useCountlyViewTracking(viewName, active) {
  useEffect(function () {
    if (active) {
      trackCountlyPageView(viewName);
      // return () => {
      //   trackCountlyPageView("")
      // };
    }
  }, [viewName, active]);
}
export { initMixpanel, initializeCountly, trackPageView, trackCountlyPageView, trackEvent, trackPageExit, trackDuration, storeMixpanelEvents, syncMixpanelEvents };